import { polyfill as polyfill } from 'mobile-drag-drop';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { isTestRun2hvu4ktvvkhb7 as isTestRun } from './IsTestRun.mjs';
import { loadImages3hq91znq8rg8h as loadImages } from './components/ImagePath.mjs';
import { loadMarkdown2slzyuwbneozg as loadMarkdown } from './components/MarkdownPaths.mjs';
import { App_instancebibmjqilchbk as App_instance } from './App.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function main() {
  import('/com/zegreatrob/coupling/client/animations.css');
  import('/com/zegreatrob/coupling/client/style.css');
  import('reactjs-popup/dist/index.css');
  import('mobile-drag-drop/default.css');
  if (isTestRun()) {
    return Unit_instance;
  }
  loadImages();
  loadMarkdown();
  polyfill();
  App_instance.x7n();
}
function mainWrapper() {
  main();
}
//region block: exports
export {
  mainWrapper as mainWrapperghrsyv1aaoq3,
};
//endregion

//# sourceMappingURL=Main.mjs.map
